export default __webpack_public_path__ + "static/media/dot-blue.16ed793b.svg";